import { NavLink } from 'react-router';
import { IconBag, IconCalendar, IconFridge, IconGrid, IconPen, IconScan, IconSliders } from './icons';
import { PATHS } from '../navigation';
import { t } from '../theme';
import { useStore } from '../store';

const NAV: Array<{
  to: string;
  label: string;
  Icon: (props: { size?: number }) => React.ReactElement;
}> = [
  { to: PATHS.dash, label: 'Übersicht', Icon: IconGrid },
  { to: PATHS.inhalt, label: 'Inhalt', Icon: IconFridge },
  { to: PATHS.scan, label: 'Scannen', Icon: IconScan },
  { to: PATHS.cal, label: 'Kalender', Icon: IconCalendar },
  { to: PATHS.shop, label: 'Einkauf', Icon: IconBag },
  { to: PATHS.notes, label: 'Notizen', Icon: IconPen },
  { to: PATHS.settings, label: 'System', Icon: IconSliders },
];

export function Rail() {
  const startScan = useStore((s) => s.startScan);
  const closeDetail = useStore((s) => s.openDetail);
  const clock = new Date().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });

  return (
    <div
      style={{
        width: 128,
        flex: 'none',
        borderRadius: 28,
        background: 'oklch(0.225 0.012 60 / 0.72)',
        backdropFilter: 'blur(20px)',
        border: t.hairline,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '22px 0 20px',
        gap: 8,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 9, marginBottom: 18 }}>
        <div
          style={{
            width: 46,
            height: 46,
            borderRadius: 15,
            background: 'linear-gradient(150deg, oklch(0.88 0.17 138), oklch(0.74 0.17 152))',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 27,
            fontWeight: 700,
            color: 'oklch(0.2 0.05 145)',
            letterSpacing: '-0.04em',
            boxShadow: '0 8px 22px -8px oklch(0.82 0.16 130 / 0.7)',
          }}
        >
          f
        </div>
        <div style={{ fontSize: 19, fontWeight: 600, letterSpacing: '-0.035em', color: 'oklch(0.94 0.01 80)' }}>
          frisk<span style={{ color: t.accent }}>.</span>
        </div>
      </div>

      {NAV.map((n) => (
        <NavLink
          key={n.to}
          to={n.to}
          // Scannen is a fresh scan, not a return to whatever the last one
          // left behind — the store resets the cycle and navigates itself.
          onClick={(e) => {
            if (n.to === PATHS.scan) {
              e.preventDefault();
              startScan();
              return;
            }
            closeDetail(null);
          }}
          // `end` on Inhalt only: it lives at "/", which prefix-matches
          // everything. Scannen wants the opposite — it stays lit through
          // /scannen/pruefen, which is a step inside it, not a destination.
          end={n.to === PATHS.dash}
          className="press"
          style={({ isActive }) => ({
            width: 104,
            padding: '12px 0 10px',
            borderRadius: 18,
            background: isActive ? 'oklch(0.3 0.012 60)' : 'transparent',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 6,
            textDecoration: 'none',
          })}
        >
          {({ isActive }) => (
            <>
              <div
                style={{
                  display: 'flex',
                  color: isActive ? t.accent : 'oklch(0.6 0.012 60)',
                  transition: 'color 120ms',
                }}
              >
                <n.Icon size={26} />
              </div>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  color: isActive ? t.ink : 'oklch(0.66 0.015 70)',
                }}
              >
                {n.label}
              </div>
            </>
          )}
        </NavLink>
      ))}

      <div style={{ flex: 1 }} />
      <div style={{ fontFamily: t.mono, fontSize: 12, letterSpacing: '0.12em', color: 'oklch(0.56 0.012 60)', textAlign: 'center', lineHeight: 1.7 }}>
        KÜCHE
        <br />
        {clock}
      </div>
    </div>
  );
}
